import { ValueFunction } from '../../index';

export const identity = new ValueFunction(
  ({series}) => series,
  {
    label: 'Identity of Series',
    parameters: [
      {'name': 'series', 'type': 'number'}
    ]
  }
);